import React from "react";
import {Loader, useProgress} from "@react-three/drei";
import room from "../../icons/Room";

const ConfLoader = () => {
    const { item } = useProgress();
    const textLoader = () => {
        if (item.includes("room")) {
            return "Загрузка помещения";
        } else {
            return "Загрузка наполнения";
        }
    };

    return (
        <Loader
            containerStyles={{
                width: "100vw",
                height: "100vh",
                zIndex: 1000000,
            }}
            innerStyles={{
                display: "flex",
                width: "20vw",
                height: "4px",
                backgroundColor: "gray",
                textAlign: "center",
                position: "relative",
            }}
            dataStyles={{ fontSize: "14px", width: "100%", position: "absolute" }}
            barStyles={{ backgroundColor: "red", height: "5px", top: "-1px" }}
            dataInterpolation={(p) => `${textLoader()} ${p.toFixed(1)}%`}
            initialState={() => true}
        />
    );
};

export default ConfLoader;
